module.exports = __webpack_public_path__ + "static/media/new_logo_colored2.a5355583.png";